import React from 'react';

const JsonSchemaFormObjectFieldTemplate = ({ TitleField, properties, title, description, ...rest }) => {
    let { schema: { root } } = rest;

    const renderField = (prop) => {
        if (prop.content.props.uiSchema.classNames && prop.content.props.uiSchema.classNames.indexOf('col') > -1) {
            return <div
                className={`object-field-wrapper ${prop.content.props.uiSchema.wrapperClassNames || 'col col-12'}`}
                key={prop.content.key}>
                <div className="row">
                    {prop.description}
                    {prop.content}
                    {prop.errors}
                    {prop.help}
                </div>
            </div>
        } else {
            return <div
                className={`object-field-wrapper ${prop.content.props.uiSchema.wrapperClassNames || 'col col-12'}`}
                key={prop.content.key}>
                {prop.description}
                {prop.content}
                {prop.errors}
                {prop.help}
            </div>
        }
    }

    if (root === true) {
        return (
            <div>
                <TitleField title={title} className="object-field" />
                <div className={root === true ? 'row' : ''}>
                    {
                        properties.map((prop, key) => {
                            let content = [];
                            if (prop.content.props.uiSchema.header) {
                                content.push(
                                    <div className="col col-12" key={prop.content.key + 'header'}>
                                        <div className=" alert alert-dark">
                                            {prop.content.props.uiSchema.header}
                                        </div>
                                    </div>
                                )
                            }

                            if (prop.content.props.uiSchema.blockLabel) {
                                content.push(
                                    <div className="col col-12" key={prop.content.key + 'header'}>
                                        <h5>
                                            {prop.content.props.uiSchema.blockLabel}
                                        </h5>
                                    </div>
                                )
                            }


                            content.push(
                                renderField(prop)
                            )

                            return content;
                        })
                    }
                </div>
                {description}
            </div>
        )
    } else {
        return properties.map((prop, key) => {
            let content = [];

            if (prop.content.props.uiSchema.header) {
                content.push(
                    <div className="col col-12" key={prop.content.key + 'header'}>
                        <div className="alert alert-dark">
                            <h3>{prop.content.props.uiSchema.header}</h3>
                        </div>
                    </div>
                )
            }

            content.push(
                renderField(prop)
            );

            return content;

        })
    }
}

export default JsonSchemaFormObjectFieldTemplate;
